import Clipboard from 'clipboard'

$(() => {

  if ($('body').attr('id') == 'download') {

    $('.mj-btn-blue')
      .on('click', function () {
        dataLayer.push({
          'event': 'mjml',
          'eventValue': 'mjmlDownload-CtaClicked',
          'button': $(this).data('download')
        })
      })

    new Clipboard('.copy')

    $('.editors .editor a')
      .on('click', function () {
        dataLayer.push({
          'event': 'mjml',
          'eventValue': 'mjmlEditor-Clicked',
          'button': $(this).data('button')
        })
      })
    
  }

})
